import { render, staticRenderFns } from "./DOrganizeEditor.vue?vue&type=template&id=71d83b6e&"
import script from "./DOrganizeEditor.vue?vue&type=script&lang=js&"
export * from "./DOrganizeEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports